import { useState, useEffect } from "react";
import { COLOR_SCHEME_DARK, COLOR_SCHEME_LIGHT } from "@graylog/sawmill";
const useBrowserColorSchemePreference = () => {
  if (!window.matchMedia) {
    return null;
  }
  const mqlLight = window.matchMedia("(prefers-color-scheme: light)");
  const mqlDark = window.matchMedia("(prefers-color-scheme: dark)");
  const prefersScheme = mqlDark.matches ? COLOR_SCHEME_DARK : COLOR_SCHEME_LIGHT;
  const [scheme, setScheme] = useState(prefersScheme);
  useEffect(() => {
    if (window.matchMedia) {
      const handleLight = (ev) => {
        if (ev.matches) {
          setScheme(COLOR_SCHEME_LIGHT);
        }
      };
      const handleDark = (ev) => {
        if (ev.matches) {
          setScheme(COLOR_SCHEME_DARK);
        }
      };
      mqlLight.addListener(handleLight);
      mqlDark.addListener(handleDark);
      return () => {
        mqlLight.removeListener(handleLight);
        mqlDark.removeListener(handleDark);
      };
    }
    return null;
  }, []);
  return scheme;
};
export default useBrowserColorSchemePreference;
